<template>
  <div class="staff_edit">
    <el-page-header @back="goBack" title content="员工编辑"></el-page-header>
    <div class="staff_edit_form">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="姓名:" style="margin-top:20px">
          <el-input v-model="form.name" placeholder="请输入姓名" :width="200"></el-input>
        </el-form-item>
        <el-form-item label="部门:" style="margin-top:20px">
          <el-input v-model="form.dept" placeholder="请输入部门" :width="200"></el-input>
        </el-form-item>
        <el-form-item label="岗位:" style="margin-top:20px">
          <el-input v-model="form.job" placeholder="请输入岗位" :width="200"></el-input>
        </el-form-item>
        <el-form-item label="手机号码:" style="margin-top:20px">
          <el-input v-model="form.mobile" placeholder="请输入手机号码" :width="200"></el-input>
        </el-form-item>
        <el-form-item label="入职时间:" style="margin-top:20px">
          <el-date-picker
            v-model="form.joinDate"
            type="date"
            placeholder="选择日期"
            :width="200"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="身份证号:" style="margin-top:20px">
          <el-input v-model="form.idcard" placeholder="请输入身份证号" :width="200"></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-switch v-model="form.isOnline" active-text="在职" inactive-text="离职"></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button @click="goBack">取消</el-button>
          <el-button type="primary" @click="subStaff">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "StaffEdit",
  data() {
    return {
      form: {
        name: "",
        mobile: "",
        joindate: "",
        job: "",
        isOnline: true,
        idcard: "",
        dept: ""
      }
    };
  },
  mounted: function() {
    this.getStaff();
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    getStaff: function() {
      this.$route.query.id
        ? this.$api.get(`/xsss/v1/staff/${this.$route.query.id}`).then(res => {
            this.form = {
              ...res.data,
              joinDate: Number(res.data.joinDate)
                ? Number(res.data.joinDate)
                : "",
              isOnline: res.data.isOnline == 1 ? true : false
            };
          })
        : null;
    },
    subStaff: function() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$api
        .post(`/xsss/v1/staff`, {
          ...this.form,
          joinDate: this.form.joinDate ? String(this.form.joinDate) : "",
          isOnline: this.form.isOnline ? 1 : 0
        })
        .then(() => {
          loading.close();
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.goBack();
        })
        .catch(() => {
          loading.close();
        });
    }
  }
};
</script>

<style scoped>
@import url("./index.css");
</style>